import Vue from 'vue'
import {helper} from "@productfinder/shared/helper";
import {constants} from '@productfinder/shared/constants';

export const mutations = {
    setConfig: (state, config) => {
        state.config = config;

        if (!config.useAccordion) {
            state.background = constants.background.light
        }
    },
    setUseHash: (state, useHash) => {
        state.useHash = useHash;
    },
    setApi: (state, payload) => {
        if (payload.url) {
            state.api = payload.url;
        }
        if (payload.baseParamName) {
            state.apiBaseParamName = payload.baseParamName;
        }
    },
    setLocalization: (state, data) => {
        state.localization = data
    },
    setFreeze: (state, freeze) => {
        state.freeze = freeze
    },
    setInitData: (state, data) => {
        Vue.set(state, 'availableFilters', data.available);
        Vue.set(state, 'results', data.entities);
    },
    setFilterStateValue: (state, { name, value }) => {
        if (state.filterStates[name]) {
            state.filterStates[name].push(value)
        } else {
            const values = [];
            values.push(value);
            Vue.set(state.filterStates, name, values);
        }
        if (state.useHash) {
            Vue.set(state, "hash", helper.generateHash(state.filterStates));
        }
    },
    replaceFilterState: (state, data) => {
        Vue.set(state, "filterStates", data);
        if (state.useHash) {
            Vue.set(state, "hash", helper.generateHash(data));
        }
    },
    removeFilterState: (state, { filterName, value }) => {
        if (value === null) {
            Vue.delete(state.filterStates, filterName);
        } else {
            const values = state.filterStates[filterName];
            if (values.length > 1) {
                const index = values.indexOf(value);
                values.splice(index, 1);
                Vue.set(state.filterStates, filterName, values);
            } else {
                Vue.delete(state.filterStates, filterName);
            }
        }
        if (state.useHash) {
            Vue.set(state, "hash", helper.generateHash(state.filterStates));
        }
    },
    setBackground: (state, background) => {
        state.background = background
    },
    setResults: (state, results) => {
        Vue.set(state, 'results', results);
    },
    appendResults: (state, results) => {
        Vue.set(state, 'results', state.results.concat(results));
    },
    setTotal: (state, total) => {
        state.total = total;
    },
    setAvailableFilters: (state, filters) => {
        Vue.set(state, 'availableFilters', filters);
    }
};
